import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var t = /*#__PURE__*/function () {
  function t() {
    var _t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

    _classCallCheck(this, t);

    this.lengths = null != _t ? _t : [], this.coords = null != e ? e : [], this.hasIndeterminateRingOrder = s;
  }

  _createClass(t, [{
    key: "isPoint",
    get: function get() {
      return 0 === this.lengths.length;
    }
  }, {
    key: "maxLength",
    get: function get() {
      return Math.max.apply(Math, _toConsumableArray(this.lengths));
    }
  }, {
    key: "size",
    get: function get() {
      return this.lengths.reduce(function (_t2, e) {
        return _t2 + e;
      });
    }
  }, {
    key: "forEachVertex",
    value: function forEachVertex(_t3) {
      var e = 0;
      this.lengths.length || _t3(this.coords[0], this.coords[1]);

      for (var s = 0; s < this.lengths.length; s++) {
        var h = this.lengths[s];

        for (var _s = 0; _s < h; _s++) {
          _t3(this.coords[2 * (_s + e)], this.coords[2 * (_s + e) + 1]);
        }

        e += h;
      }
    }
  }, {
    key: "clone",
    value: function clone(e) {
      return e ? (e.set(this.coords), new t(this.lengths.slice(), e, this.hasIndeterminateRingOrder)) : new t(this.lengths.slice(), this.coords.slice(), this.hasIndeterminateRingOrder);
    }
  }]);

  return t;
}();

export { t as default };